/**
 * service-coverage.ts — group Secure Score recommendations by `service` (Entra
 * ID / Defender / Exchange / SharePoint / Intune / Teams) and return percent
 * implemented per service. Used by the "Coverage by service" bar list (§7.5).
 */

import type { SecureScoreControlProfile } from '@/types/secureScore'

export interface ServiceCoverageRow {
  service: string
  total: number
  implemented: number
  /** 0-100 integer percent. Zero when total is zero. */
  pct: number
}

export function coverageByService(
  recs: SecureScoreControlProfile[],
): ServiceCoverageRow[] {
  const map = new Map<string, { total: number; implemented: number }>()
  for (const rec of recs) {
    if (!rec.service) continue
    const cur = map.get(rec.service) ?? { total: 0, implemented: 0 }
    cur.total += 1
    if (rec.isImplemented) cur.implemented += 1
    map.set(rec.service, cur)
  }
  return [...map.entries()]
    .map(([service, { total, implemented }]) => ({
      service,
      total,
      implemented,
      pct: total > 0 ? Math.round((implemented / total) * 100) : 0,
    }))
    .sort((a, b) => b.pct - a.pct)
}
